import { useCallback, useEffect, useMemo, useState } from 'react';

const mesmoConjunto = (a: Set<string>, b: Set<string>) =>
    a.size === b.size && Array.from(a).every(chave => b.has(chave));

export const useSelecaoAcoes = (iniciais: string[]) => {
    const base = useMemo(() => new Set(iniciais), [iniciais.join('|')]);
    const [selecionadas, setSelecionadas] = useState<Set<string>>(base);

    useEffect(() => {
        setSelecionadas(base);
    }, [base]);

    const alternar = useCallback((chave: string) => {
        setSelecionadas(atual => {
            const novo = new Set(atual);
            if (novo.has(chave)) novo.delete(chave);
            else novo.add(chave);
            return novo;
        });
    }, []);

    const todosMarcados = useCallback(
        (chaves: string[]) =>
            chaves.length > 0 && chaves.every(c => selecionadas.has(c)),
        [selecionadas],
    );

    const marcarTodos = useCallback((chaves: string[]) => {
        setSelecionadas(atual => {
            const novo = new Set(atual);
            const todas = chaves.length > 0 && chaves.every(c => atual.has(c));
            chaves.forEach(c => (todas ? novo.delete(c) : novo.add(c)));
            return novo;
        });
    }, []);

    const alterado = useMemo(
        () => !mesmoConjunto(selecionadas, base),
        [selecionadas, base],
    );

    return { selecionadas, alternar, marcarTodos, todosMarcados, alterado };
};
